import { server } from '../server';
export const getUserProfile = async (walletAddress) => {
    const response = await server.get({ endpoint: 'user/me' }, {
        needAuthentication: true,
        walletAddress,
    });
    if (!response.ok) {
        throw new Error(`Error fetching user profile: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
export const updateUserProfile = async (walletAddress, name) => {
    const response = await server.put({ endpoint: 'user/me' }, {
        body: JSON.stringify({ name }),
        headers: {
            'Content-Type': 'application/json',
        },
        needAuthentication: true,
        walletAddress,
    });
    if (!response.ok) {
        throw new Error(`Error updating user profile: ${response.statusText}`);
    }
};
export const getGraduatedTokens = async (account, chainLayer) => {
    const response = await server.get({
        endpoint: `user/${account}/agent/graduated/not-unwrapped`,
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error fetching graduated tokens: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
